<template>
  <div class="sp-template">
    <div class="h-title">货物上架</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model.lazy="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40504)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(40504)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40502)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40503)" label="完成" name="1"></el-tab-pane>
				</el-tabs>
        <!-- <el-button size="small" v-show="in_configs(40501) && queryForm.status==0" class="btn-cyan" @click="openStockInDlog">货物上架</el-button> -->
      </div>
      <!-- 待处理表格 -->
      <el-table v-show="queryForm.status==0" :data="pendingData" border stripe style="width: 100%">
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.warehouseCode]}}
            </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>
        <el-table-column prop="refNumber" label="客户单号"></el-table-column>
        <el-table-column prop="totalCarton" label="预报箱数"></el-table-column>
        <el-table-column prop="doneCarton" label="已上架箱数"></el-table-column>
        <el-table-column prop="createAt" label="预报时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" v-if="in_configs(40501) " type="text" @click="stockInGoods( scope.row)">上架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 完成的表格 -->
      <el-table ref="multipleTable" v-show="queryForm.status==1" border :data="doneTableData" tooltip-effect="dark" style="width: 100%">
        <!-- <el-table-column prop="palletCode" label="托板号" width="160px"></el-table-column> -->
        <el-table-column prop="spaceCode" label="仓位" width="150px"></el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i">{{customerMaps[d.orgOwner]}}</p>
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i"> {{channelsMaps[d.product]}}</p>
          </template>
        </el-table-column>
        <el-table-column label="订单号">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i">{{d.orderId}}</p>
          </template>
        </el-table-column>
        <el-table-column label="货物类型" width="100px">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i">{{d.goodsType}}</p>
          </template>
        </el-table-column>
        <el-table-column label="货物箱数" width="100px">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i">{{d.totalCarton}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="50px">
          <template slot-scope="scope">
            <p v-for="(d, i) in scope.row.baseDtos" :key="i">
              <a class="look-icon" v-show="queryForm.status == 1" href="#" @click.prevent="handleLook(scope.row, d)">查看</a>
            </p>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 查看订单上架信息 -->
    <el-dialog title="订单信息" :visible.sync="dialogTableVisible" width="1000px">
      <el-form :model="palletCarton" size="small" label-width="80px" label-position="left">
        <el-form-item label="订单号">{{palletCarton.orderId}}</el-form-item>
        <el-form-item label="当前箱数">{{palletCarton.totalCarton}}</el-form-item>
      </el-form>
      <el-table :data="palletCarton.details" border stripe style="width: 100%;">
        <el-table-column prop="cartonNumber" label="箱号" width="220px"></el-table-column>
        <el-table-column label="长(cm)">
          <template slot-scope="scope">
            <span>{{scope.row.measureData.length}}</span>
          </template>
        </el-table-column>
        <el-table-column label="宽(cm)">
          <template slot-scope="scope">
            <span>{{scope.row.measureData.width}}</span>
          </template>
        </el-table-column>
        <el-table-column label="高(cm)">
          <template slot-scope="scope">
            <span>{{scope.row.measureData.height}}</span>
          </template>
        </el-table-column>
        <el-table-column label="重量(kg)">
          <template slot-scope="scope">
            <span>{{scope.row.measureData.weight}}</span>
          </template>
        </el-table-column>
        <el-table-column label="体积(cm³)">
          <template slot-scope="scope">
            <span>{{scope.row.measureData.length*scope.row.measureData.width*scope.row.measureData.height}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 上架 -->
    <el-dialog title="货物上架" class="common-select80__dialog" :visible.sync="clearanceVisible" width="500px" :show-close="false">
      <el-form :model="stockInDoneData" size="small">
        <!-- <el-form-item label="仓库" label-width="120px">
          <el-select v-model.lazy="stockInDoneData.warehouseCode" @change="changeWarehouse()">
            <el-option v-for="(d, i) in warehouseData" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架箱号" label-width="120px">
          <el-tag :key="tag" v-for="tag in stockInDoneData.cartonCodes" closable :disable-transitions="false" @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="cartonCodes" ref="saveCartonInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">添加箱号</el-button>
        </el-form-item> -->

        <!-- <el-form-item label="托板号" label-width="120px">
          <el-input v-model.trim="stockInDoneData.palletCode" placeholder="托板号"></el-input>
        </el-form-item> -->
        <el-form-item label="上架仓位">
          <el-select v-model.lazy="stockInDoneData.spaceCode" filterable remote :remote-method="getWarehouseArea">
            <el-option v-for="(d, i) in areaData" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelStockIn">取 消</el-button>
        <el-button size="small" type="primary" @click="stockInDone">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttonDisable: true,
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        orderIds: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      areaData: [],
      clearanceVisible: false,
      stockInDoneData: {
        warehouseCode: "",
        cartonCodes: [],
        palletCode: "",
        spaceCode: ""
      },
      pendingData: [],
      doneTableData: [],
      palletCarton: {},
      
      warehouses:[],
        warehouseMap: {},

      dialogTableVisible: false,
      multipleSelection: [],
      inputVisible: false,
      cartonCodes: "",
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1 //当前页
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
        _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
        });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
          {
            withCredentials: true
          }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
          {
            withCredentials: true
          }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
          {
            withCredentials: true
          }
      );
    },
    //获取区域
    changeWarehouse() {
      let query = this.stockInDoneData.warehouseCode;
      if (query !== "") {
        this.$request1({
          method: 'GET',
          url: '/area/' + query + '',
          withCredentials: true
        })
          .then(response => {
            this.areaData = response.data;
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.$notify.error({
                title: "错误",
                message: error.response.data
              });
            }
          });
      } else {
        this.areaData = [];
      }
    },
    reset() {
      this.orderIds = ""
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      }
      this.searchTask()
    },
    getWarehouseArea(query) {
      if (this.stockInDoneData.warehouseCode == "") {
        this.$notify.info({
          title: "提示",
          message: "请选择仓库"
        });
        return;
      }
      if (query !== "") {
        this.$request1({
          method: 'GET',
          url: '/area/' + this.stockInDoneData.warehouseCode + '',
          withCredentials: true,
          params: {
            area: query
          }
        })
          .then(response => {
            this.areaData = response.data;
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.$notify.error({
                title: "错误",
                message: error.response.data
              });
            }
          });
      } else {
        this.areaData = [];
      }
    },
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
        let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

      this.$request1({
        method: 'post',
        url: '/operation/stock-in/query',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
            warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.total = data.total;
            if (this.total > 0) {
              if (this.queryForm.status == 0) {
                this.pendingData = taskData;
              } else {
                this.doneTableData = taskData;
              }
            } else {
              this.pendingData = [];
              this.doneTableData = [];
              this.total = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response && error.response.data) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    openStockInDlog() {
      if (this.pendingData && this.pendingData.length > 0) {
        this.clearanceVisible = true;
      } else {
        this.$notify.info({
          title: "消息",
          message: "没有需要上架的任务"
        });
      }
    },
    //上架操作
    stockInGoods(row) {
      console.log(row);
      this.clearanceVisible = true;
      this.stockInDoneData = {
        warehouseCode: row.warehouseCode,
        palletCode: "",
        spaceCode: "",
        orderId: row.orderId
      };
      this.changeWarehouse();
    },
    //查看
    handleLook(row, detail) {
      //显示卡板上面订单的箱信息
      let palletId = row.palletId;
      let spaceId = row.spaceId;
      let orderId = detail.orderId;
      this.$request1({
        method: 'GET',
        url: '/operation/' + spaceId + '/stock-in/' + orderId + '',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          this.palletCarton.orderId = orderId;
          this.palletCarton.totalCarton = detail.totalCarton;

          this.palletCarton.details = data;
          this.dialogTableVisible = true;
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
      //通过卡板号，区域号，订单号查询卡板号上面的订单箱信息
    },
    //关闭窗口
    cancelStockIn() {
      this.clearanceVisible = false;
      this.stockInDoneData = {
        warehouseCode: "",
        cartonCodes: [],
        palletCode: "",
        spaceCode: ""
      };
    },
    //完成上架
    stockInDone() {
      // if (
      //   this.stockInDoneData.warehouseCode == null ||
      //   this.stockInDoneData.warehouseCode == ""
      // ) {
      //   this.$notify.error({
      //     title: "错误",
      //     message: "请选择仓库"
      //   });
      //   return;
      // }
      // if (
      //   this.stockInDoneData.cartonCodes == null ||
      //   this.stockInDoneData.cartonCodes.length == 0
      // ) {
      //   this.$notify.error({
      //     title: "错误",
      //     message: "箱号不能为空"
      //   });
      //   return;
      // }
      // if (
      //   this.stockInDoneData.palletCode == null ||
      //   this.stockInDoneData.palletCode == ""
      // ) {
      //   this.$notify.error({
      //     title: "错误",
      //     message: "托盘号不能为空"
      //   });
      //   return;
      // }
      if (
        this.stockInDoneData.spaceCode == null ||
        this.stockInDoneData.spaceCode == ""
      ) {
        this.$notify.error({
          title: "错误",
          message: "仓位号不能为空"
        });
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/operation/stock-in',
        withCredentials: true,
        data: this.stockInDoneData
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.clearanceVisible = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.stockInDoneData = {
              warehouseCode: "",
              cartonCodes: [],
              palletCode: "",
              spaceCode: ""
            };
            setTimeout(() => {
              this.query();
            }, 1500);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },

    // 添加箱号处理
    handleClose(tag) {
      this.stockInDoneData.cartonCodes.splice(
        this.stockInDoneData.cartonCodes.indexOf(tag),
        1
      );
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveCartonInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let cartonCodes = this.cartonCodes;
      if (
        cartonCodes &&
        this.stockInDoneData.cartonCodes.indexOf(cartonCodes.trim()) == -1
      ) {
        this.stockInDoneData.cartonCodes.push(cartonCodes.trim());
      }
      this.inputVisible = false;
      this.cartonCodes = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.look-icon{
  font-size: 12px;
  color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/shelvesgoods.vue